var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"notFound"},[_c('div',{staticClass:"notFound__body"},[_c('p',[_vm._v("エラーが発生しました")]),_vm._v(" "),_c('Btn',{staticClass:"withdraw",attrs:{"label":'ホームに戻る',"color":'red'},nativeOn:{"click":function($event){return _vm.back.apply(null, arguments)}}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d846f4d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/errors/500.vue
// module id = null
// module chunks = 